import { event } from './event';

export const seo = {
  lang: 'fr',
  locale: 'fr_MA',
  title: 'Deuxième webinaire – La Rentrée Touristique by CNT',
  description:
    'Accédez au deuxième webinaire de La Rentrée Touristique, organisé par la Confédération Nationale du Tourisme (CNT) : remplissez le formulaire dès maintenant et rejoignez le live le vendredi 9 octobre 2026 à partir de 16h00.',
  siteName: 'La Rentrée Touristique by CNT',
  image: event.eventLogo,
  imageAlt: 'Logo La Rentrée Touristique by CNT',
  themeColor: '#EFEFEF',
  keywords:
    'Rentrée Touristique, CNT, Confédération Nationale du Tourisme, webinaire, tourisme Maroc, live',
  eventStart: event.broadcastStart,
  organizerName: 'Confédération Nationale du Tourisme',
};
